import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sprint: {
		id: 'software-reports.velocity-report.grid.sprint',
		defaultMessage: 'Sprint',
		description: '',
	},
	commitment: {
		id: 'software-reports.velocity-report.grid.commitment',
		defaultMessage: 'Commitment',
		description: '',
	},
	completed: {
		id: 'software-reports.velocity-report.grid.completed',
		defaultMessage: 'Completed',
		description: '',
	},
});
